import {
  clearNotifyMeWarningForSession,
  sessionHasNotifyMeWarningStored
} from "../../services/backInStock/notifyMeWarning";
import { showWarningBanner } from "../modules/savedItems/actions";
import { hasJustLoggedIn } from "../../services/identity";

export const handleNotifyMeWarning = () => dispatch => {
  if (sessionHasNotifyMeWarningStored()) {
    clearNotifyMeWarningForSession();

    if (hasJustLoggedIn()) {
      dispatch(showWarningBanner({ showWarningBanner: true }));
    }
  }
};
